<mat-toolbar color="primary" class="header">
  <div class="header-left">
    <span class="header-sigla">SEFAZ-MS</span>
    <span class="header-title">SCAJ — Sistema de Controle de Ações Judiciais</span>
  </div>
  <span class="spacer"></span>
  <span class="header-user" *ngIf="auth.usuario$ | async as u">    
	{{ u.nome }} - {{ u.unidadeLocalTrabalho?.sigla || u.unidadeOrganizacional || 'Sem unidade' }}
  </span>
  <button mat-icon-button (click)="logout()" matTooltip="Sair">
    <mat-icon>logout</mat-icon>
  </button>
</mat-toolbar>